import { useAuth } from '../../context/AuthContext';
import { Table, Alert, Badge } from 'react-bootstrap';
import { formatDate, formatCurrency } from '../../utils/formatters';
import BenefitStatusBadge from '../../utils/BenefitStatusBadge';

const BenefitHistoryTable = ({ benefits, appliedPledgeTypes }) => {

  const { isAdmin } = useAuth();
  
  if (!benefits || benefits.length === 0) {
    // Show CCB pledge info if available but no Assist records
    if (appliedPledgeTypes && appliedPledgeTypes.length > 0) {
      return (
        <Alert variant="warning" className="mb-0">
          No benefits found in Assist history, but customer has benefits applied in CCB: <strong>{appliedPledgeTypes.join(', ')}</strong>
        </Alert>
      );
    }
    return (
      <Alert variant="info" className="mb-0">
        No previous benefits found for this customer.
      </Alert>
    );
  }

  return (
    <Table size="sm" hover responsive className="mb-0">
      <thead>
        <tr>
          <th>Date</th>
          <th>Applicant</th>
          <th className="text-center">Auto-Enroll</th>
          <th className="text-center">Fund Type</th>
          <th>Pledge</th>
          <th>Discount</th>
          <th className="text-center">Status</th>
        </tr>
      </thead>
      <tbody>
        {benefits.map((benefit, index) => (
          <tr key={benefit.id || index}>
            <td>{formatDate(benefit.createTstamp)}</td>
            <td>{benefit.name || '-'}</td>
            <td className="text-center">{benefit.energyDiscount > 0 ? (benefit.username === 'AUTOENROLL' ? 'Yes' : 'No') : '-'}</td>
            <td className="text-center">{benefit.fundType || '-'}</td>
            <td>{formatCurrency(benefit.pledgeAmount, '-')}</td>
            <td>{benefit.energyDiscount != null ? `${benefit.energyDiscount}%` : '-'}</td>
            <td className="text-center">
              <BenefitStatusBadge status={benefit.status} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default BenefitHistoryTable;
